/**
 * Tool approval query operations - Create
 */

import { v4 as uuidv4 } from 'uuid';
import type { UserId } from '../../types.js';
import { getSupabaseClient } from '../../supabase-client.js';
import type { StoredToolApproval } from '../types.js';
import { logger } from '../../../logger.js';

/**
 * Create a tool approval request
 */
export async function createApproval(
  approval: Omit<StoredToolApproval, 'id' | 'created_at' | 'updated_at'>,
  approvalId?: string
): Promise<StoredToolApproval> {
  try {
    const client = getSupabaseClient();
    const now = new Date().toISOString();

    const { data, error } = await client
      .from('meridian_tool_approvals')
      .insert({
        id: approvalId || uuidv4(),
        ...approval,
        created_at: now,
        updated_at: now,
      })
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data as StoredToolApproval;
  } catch (error) {
    logger.error('error creating approval', error, { op: 'createApproval' });
    throw error;
  }
}
